import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import VerticalDivider from '@/common/components/VerticalDivider/VerticalDivider'

import * as Styles from './styles'

const ParcelCardCarrier = ({ carrier, trackingNumber }) => {
  const theme = useTheme()

  if (!carrier && !trackingNumber) return null

  return (
    <Styles.Container>
      {carrier?.logo_url && <Styles.CarrierLogo src={carrier.logo_url} alt="carrier logo" />}
      {carrier?.name && <Text type="bodyMMedium">{carrier.name}</Text>}
      {carrier?.name && trackingNumber && <VerticalDivider role="separator" aria-orientation="vertical" />}
      {trackingNumber && (
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {`#${trackingNumber}`}
        </Text>
      )}
    </Styles.Container>
  )
}

export default ParcelCardCarrier
